import React from 'react';
import { Route } from 'react-router';
import { AsyncSwitch } from '@wearejh/m2-pwa-engine/lib/router/AsyncSwitch';

import { paths } from '../../config.json';

import { BranchesLanding } from './BranchesLanding';
import { BranchView } from './BranchView';

export function BranchesRoutes() {
    return (
        <AsyncSwitch base={paths.storeLocator.storeLocator}>
            <Route exact path={paths.storeLocator.detail}>
                <BranchView />
            </Route>

            <Route exact path={paths.storeLocator.storeLocator}>
                <BranchesLanding />
            </Route>
        </AsyncSwitch>
    );
}
